<div class="container" [formGroup]="gradientForm">
  <div class="handles" formArrayName="items" >
    @for (control of items.controls; track control){
      <div class="handle" [formGroupName]="$index">
      <div
        class="color-container"
      >
        <div
          class="color-picker"
          cpPosition="top-left"
          cpAlphaChannel="disabled"
          [colorPicker]="control.value.color"
          [style.background]="control.value.color"
          [cpEyeDropper]="true"
          [cpUseRootViewContainer]="true"
          (colorPickerChange)="updateColor(control, $event)"
        >
        </div>
      </div>
        <p-inputNumber
          formControlName="position"
          mode="decimal"
          maxFractionDigits="0"
          suffix="%"
          max="100"
          min="0"
        ></p-inputNumber>
        <p-button icon="pi pi-clone" [rounded]="true" [text]="true" severity="success" (onClick)="cloneClick(control)" />
        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (onClick)="deleteClick(control)"/>
      </div>
    }
  </div>
  <div class="preview">
  </div>
</div>
